import { render, staticRenderFns } from "./teamPage.vue?vue&type=template&id=7c674dfa&scoped=true"
import script from "./teamPage.vue?vue&type=script&lang=js"
export * from "./teamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c674dfa",
  null
  
)

export default component.exports